import { Injectable } from '@angular/core';
import { ContactCardDto, SearchContactsOptions } from '@hub/generated/models';
import { SearchController } from '@hub/generated/services';
import { eContactSection, eSearchContactType } from '@hub/generated/enums';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { Functions } from '@hub/common/Functions';

@Injectable({ providedIn: 'root' })
export class SearchService {

  constructor(
    private searchController: SearchController
  ) { }

  adminAgentsSearch$: Observable<ContactCardDto[]>;
  buyersSearch$: Observable<ContactCardDto[]>;
  contactAgentsSearch$: Observable<ContactCardDto[]>;
  clientsSearch$: Observable<ContactCardDto[]>;
  contactsSearch$: Observable<ContactCardDto[]>;

  searchAdminAgent(event: any): any {
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = [eSearchContactType.User]

    this.adminAgentsSearch$ = this.searchController
      .SearchContacts(searchParameters)
      .pipe(share());
  }

  searchClient(event: any): any {
    
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = [eSearchContactType.Client]

    this.clientsSearch$ = this.searchController
      .SearchContacts(searchParameters)
      .pipe(share());
  }

  searchContactAgent(event: any): any {
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = [eSearchContactType.Contact]

    this.contactAgentsSearch$ = this.searchController
      .SearchContacts(searchParameters)
      .pipe(share());
  }

  searchBuyer(event: any): any {
   
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = [eSearchContactType.Buyer]

    this.buyersSearch$ = this.searchController
      .SearchContacts(searchParameters)
      .pipe(share());
  }

  searchContact(event: any): any {

    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(event.query);
    searchParameters.Types = [eSearchContactType.Contact]

    this.contactsSearch$ = this.searchController
      .SearchContacts(searchParameters)
      .pipe(share());
  }

  searchContact$ = (search: string) => {
    
    let searchParameters: SearchContactsOptions = Functions.GetInstanceSearchContactsOptions(search);
    searchParameters.Types = [eSearchContactType.Contact]     
    return this.searchController.SearchContacts(searchParameters)
  }

  // public searchService: TVPSearchService

  // [suggestions]="searchService.adminAgentsSearch$ | async"
  // (completeMethod)="searchService.searchAdminAgent($event)"
  // (onDropdownClick)="searchService.searchAdminAgent($event)"

  // [suggestions]="searchService.buyersSearch$ | async"
  // (completeMethod)="searchService.searchBuyer($event)"
  // (onDropdownClick)="searchService.searchBuyer($event)"

  // [suggestions]="searchService.clientsSearch$ | async"
  // (completeMethod)="searchService.searchClient($event)"
  // (onDropdownClick)="searchService.searchClient($event)"

  // [suggestions]="searchService.contactAgentsSearch$ | async"
  // (completeMethod)="searchService.searchContactAgent($event)"
  // (onDropdownClick)="searchService.searchContactAgent($event)"
}
